import { isNaN } from 'lodash'
import { useState, useEffect } from 'react'

import { MaskInput } from 'components/MaskInput'

export const InputNumber = ({ value, maskOptions = {}, onChange, disabled, ...props }: TSFixMe): TSFixMe => {
  const prefix = maskOptions.prefix || ''
  const suffix = maskOptions.suffix || ''

  const [inputValue, setInputValue] = useState(value.toString())

  const handleInputChange = (newValue: TSFixMe, mask: TSFixMe): TSFixMe => {
    setInputValue(newValue)

    if (value.toString() !== mask._unmaskedValue) {
      onChange(mask._unmaskedValue)
    }
  }

  useEffect((): void => {
    setInputValue(value.toString())
  }, [value])

  const unmaskedInputValue = inputValue.replace(prefix, '').replace(suffix, '')
  const lazy = isNaN(parseFloat(unmaskedInputValue))
  return (
    <MaskInput
      lazy={lazy}
      mask={`${prefix}num${suffix}`}
      blocks={{
        num: {
          mask: Number,
          scale: maskOptions.allowDecimal ? 2 : 0,
          max: maskOptions.max || undefined,
          min: maskOptions.min || undefined,
          radix: '.',
          thousandsSeparator: maskOptions.thousandsSeparator ?? ',',
          padFractionalZeros: disabled
        }
      }}
      value={inputValue}
      onChange={(): void => {
        // do nothing
      }}
      onAccept={handleInputChange}
      disabled={disabled}
      {...props}
    />
  )
}
